// extracted by mini-css-extract-plugin
module.exports = {"promo":"styles_promo__FcrG3","wrapper":"styles_wrapper__1MAEi","list":"styles_list__1EhpU"};